<div class="row mt-2">
  <div class="col-10 offset-1">
    <ul class="list-inline">
      <li class="list-inline-item"><stumpy-settings></stumpy-settings></li>
      <li class="list-inline-item"><stumpy-guide></stumpy-guide></li>
      <li class="list-inline-item"><stumpy-reset></stumpy-reset></li>
      <li class="list-inline-item"><stumpy-go-mode></stumpy-go-mode></li>
    </ul>
  </div>
</div>
